<template>
  <v-container fluid>
  <v-row justify="center">
    <v-col sm="12" md="12" lg="10">
      <v-card>
        <v-card-title>
          Chemical Inventory
          <v-spacer />
          <v-text-field
            clearable
            prepend-inner-icon="search"
            v-model="search"
          />
          <v-btn
            icon
            @click="initialize"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-card-title>
        <v-data-table
          :items="listData.listEntries"
          :loading="loading"
          :headers="headers"
          :items-per-page="100"
          :search="search"
        >
          <template v-slot:item.c3b047c8-eb92-4472-8006-eda287beddbc_references_sort="{ item }">
            <div v-for="thing in item['c3b047c8-eb92-4472-8006-eda287beddbc_references_sort']" :key="thing.id">
              {{ thing.displayString }}
            </div>
          </template>
          <template v-slot:item.27788270-8e36-4e4a-a7e1-08e50f613344_references_sort="{ item }">
            <div v-for="thing in item['27788270-8e36-4e4a-a7e1-08e50f613344_references_sort']" :key="thing.id">
              {{ thing.displayString }}
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import api from "../../services/api.zenkit"
export default {
  name: "ChemicalListView",
  data() {
    return {
      loading: true,
      listData: {},
      search: "",
      headers: [
        { text: 'CAS #', value: '4d235138-6b20-4e74-b270-72f113c7a994_text'},
        { text: 'Chemical Name', value: '53dbf282-961f-485c-8df3-1779b8949cc3_text'},
        { text: 'Manufacturer', value: '21a094c4-971e-417a-9879-cd2b3148d286_text'},
        { text: 'Lot Number', value: '9772bd76-b648-4598-94ed-e577d0a3c5a0_text'},
        { text: 'Location', value: 'c3b047c8-eb92-4472-8006-eda287beddbc_references_sort'},
        { text: 'Control Area', value: '27788270-8e36-4e4a-a7e1-08e50f613344_references_sort'}
      ]
    }
  },
  methods: {
    initialize() {
      this.loading = true;
      api
        .post('lists/P2oaIN8Ey/entries/filter/list', {
          "filter": {},
          "groupByElementId": 0,
          "limit": 1000,
          "skip": 0,
          "exclude": [],
          "allowDeprecated": false,
          "taskStyle": false
        })
        .then((response) => {
          this.listData = response.data
        })
        .finally(() => this.loading = false)
    }
  },
  mounted(){
    this.initialize()
  }

}
</script>
